import {FeatureTablesDispatcher} from '../core/dispatchers'
import {IFeatureTablesDispatcher} from '../core/interfaces/dispatchers'

class AppFeatureTablesDispatcher extends FeatureTablesDispatcher {}

export const appFeatureTablesDispatcher = new AppFeatureTablesDispatcher() as IFeatureTablesDispatcher
